import { Body, FileUpload, FlexBox, FormControl, Headline } from '@Backlot-Cars/archie';

const DriversLicenseUploadField = ({
	register,
	name,
	errors,
	lastFileName,
	lastFileUrl,
	handleRemove,
	description,
	fileTypesText,
	fileTypesSize,
	accept,
}) => (
	<FlexBox flexDirection="column" gap="sm">
		<FlexBox gap="xxs">
			<Headline>Driver&apos;s license</Headline>
			<Body color="alert">*</Body>
		</FlexBox>
		<Body>{description}</Body>
		<Body bold size={fileTypesSize}>
			{fileTypesText}
		</Body>
		<FormControl required formErrors={errors}>
			<FileUpload
				accept={accept}
				lastFileName={lastFileName}
				lastFileUrl={lastFileUrl}
				handleRemove={handleRemove}
				fullWidth
				{...register(name)}
			/>
		</FormControl>
	</FlexBox>
);

export default DriversLicenseUploadField;
